import { Button, ButtonGroup, Checkbox, Dropdown, Field, NumericInput, TextOutput } from 'Components/Core';
import { FormatTypes } from 'Lib/Format';
import { pipe } from 'Lib/Hooks/Selectors';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { FieldSet, ListFieldSection } from '../../../../Layout';
import { WorksheetBalanceFieldSet, WorksheetEquipmentDropdown } from '../../../Core';
import { IEmbeddedTestProps } from '../types';

let BsEnPreparationSection: React.FC<IEmbeddedTestProps> = ({ createWorksheetSelector, isEmbeddedTest }) => {
  const [testConditionsEditable, setTestConditionsEditable] = useState(false);

  const visualNominalParticleSizeSieveOptions = useSelector(
    pipe(createWorksheetSelector!('Preparation.AllVisualNominalParticleSizeSieves'), (diameters) =>
      (diameters || []).map((diameter: any) => ({
        value: diameter.Id,
        label: diameter.Caption,
      }))
    )
  );

  return (
    <>
      {/* Editable fields */}
      {!isEmbeddedTest && (
        <ListFieldSection visible={testConditionsEditable}>
          <Field input={<NumericInput />} name="Equipment.DryingTemperature" />
          <Field input={<Checkbox />} name="Preparation.LightweightAggregate" />
        </ListFieldSection>
      )}

      {/* Read-only fields */}
      {!isEmbeddedTest && (
        <ListFieldSection visible={!testConditionsEditable}>
          <Field input={<TextOutput />} name="Equipment.DryingTemperature" />
          <Field input={<TextOutput />} name="Preparation.LightweightAggregate" format={{ type: FormatTypes.YesNo }} />
          <FieldSet>
            <ButtonGroup>
              <Button
                onClick={() => {
                  setTestConditionsEditable(true);
                }}
              >
                Change
              </Button>
            </ButtonGroup>
          </FieldSet>
        </ListFieldSection>
      )}

      <ListFieldSection>
        <Field
          input={<Dropdown />}
          name="Preparation.VisualNominalParticleSize"
          options={visualNominalParticleSizeSieveOptions}
          simpleValue
        />
        <WorksheetBalanceFieldSet name="Equipment.Balance" />
        <Field input={<WorksheetEquipmentDropdown />} equipmentType="oven" name="Equipment.Oven" />
      </ListFieldSection>
    </>
  );
};

BsEnPreparationSection = withInjectedProps(BsEnPreparationSection);

export { BsEnPreparationSection };
export default BsEnPreparationSection;
